import Vue from 'vue';
import MainMenu from './components/Navigation/MainMenu.vue';

const mainMenuEl = document.getElementById('main-menu');

if (mainMenuEl) {
  new Vue({
    el: mainMenuEl,
    components: {
      MainMenu
    }
  });
}
